import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../../environments/environment';
import { AssignmentParticipantSkillsUpdateModel } from '../models/assignment-participants/assignment-participant-skills-update.model';
import { AssignmentParticipantSkillsModel } from '../models/assignment-participants/assignment-participant-skills.model';

@Injectable({
    providedIn: 'root'
})
export class AssignmentParticipantSkillsService {

    constructor(private httpClient: HttpClient) { }

    getIsSkillAllocationAllowed(assignmentId: number): Observable<boolean> {
        return this.httpClient.get<boolean>(`${environment.api}/assignments/${assignmentId}/participants/skills/isAllocationAllowed`);
    }

    getAssignmentParticipantSkill(assignmentId: number): Observable<AssignmentParticipantSkillsModel[]> {
        return this.httpClient.get<AssignmentParticipantSkillsModel[]>(`${environment.api}/assignments/${assignmentId}/participants/skills`);
    }

    updateAssignmentParticipantSkill(assignmentId: number, participantsSkills: AssignmentParticipantSkillsUpdateModel[]): Observable<void> {
        return this.httpClient.post<void>(`${environment.api}/assignments/${assignmentId}/participants/skills`, participantsSkills);
    }
}
